<template>
  <div class="bg-white border-neutral-200 flex items-start justify-between">

    <div class="flex space-x-10 align-top items-center">
      <NuxtLink class="hidden md:block font-medium" to="/docs/about">About&nbsp;us</NuxtLink>
      <cart-drawer/>
    </div>
  </div>

</template>
<script lang="ts" setup>
</script>
